import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { PropsWithChildren } from "react";

interface Props extends PropsWithChildren {
  title: string;
  fullWidth?: boolean;
}

export const EditPageLayout = ({ children, title, fullWidth }: Props) => {
  return (
    <Box sx={{ maxWidth: fullWidth ? "lg" : "730px", width: "100%", mb: 3 }}>
      <Typography variant="h4" gutterBottom sx={{ paddingTop: "15px", fontSize: "32px" }}>
        {title}
      </Typography>
      {children}
    </Box>
  );
};
